import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M8.012 7.01 12.27 2.75a.723.723 0 1 0-1.021-1.021L6.99 5.988 2.733 1.73A.723.723 0 0 0 1.71 2.751L5.97 7.01l-4.258 4.259a.723.723 0 0 0 1.021 1.02l4.259-4.257 4.258 4.258a.723.723 0 0 0 1.021-1.021z" }, null, -1)
  ]))]))
}
export default { render: render }